// extracted by mini-css-extract-plugin
module.exports = {"cursor-pointer":"styles-module__cursor-pointer___3XH0v","blue-border":"styles-module__blue-border___13TqV","box-shadow":"styles-module__box-shadow___2c9_j"};